export default "__VITE_ASSET__CkMtqU5B__"